import { BaseInfoCard, baseCardStyles } from "./base-info-card.js";

const template = document.createElement("template");

template.innerHTML = `
  <style>
    ${baseCardStyles}

    .icon-container {
      border-radius: 9999px;
      background-color: color-mix(in srgb, var(--p-primary-color, var(--p-emerald-500, #10b981)) 12%, transparent);
      color: var(--p-primary-color, var(--p-emerald-500, #10b981));
    }

    :host-context(.app-dark) .icon-container,
    :host-context(.dark) .icon-container,
    :host-context(.p-dark) .icon-container,
    :host-context([data-theme="dark"]) .icon-container,
    :host-context([theme="dark"]) .icon-container,
    :host([theme="dark"]) .icon-container {
      background-color: color-mix(in srgb, var(--p-primary-color, var(--p-emerald-400, #34d399)) 20%, transparent);
      color: var(--p-primary-color, var(--p-emerald-400, #34d399));
    }

    .card-value {
      color: var(--p-primary-color, var(--p-emerald-500, #10b981));
    }

    :host-context(.app-dark) .card-value,
    :host-context(.dark) .card-value,
    :host-context(.p-dark) .card-value,
    :host-context([data-theme="dark"]) .card-value,
    :host-context([theme="dark"]) .card-value,
    :host([theme="dark"]) .card-value {
      color: var(--p-primary-color, var(--p-emerald-400, #34d399));
    }

    .card-bottom {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .upgrade-link {
      font-size: 0.9375rem;
      font-weight: 700;
      color: var(--p-primary-color, var(--p-emerald-500, #10b981));
      transition: color 0.15s ease;
    }

    .upgrade-link:hover {
      color: var(--p-primary-hover-color, var(--p-emerald-600, #059669));
      text-decoration: underline;
    }

    :host-context(.app-dark) .upgrade-link,
    :host-context(.dark) .upgrade-link,
    :host-context(.p-dark) .upgrade-link,
    :host-context([data-theme="dark"]) .upgrade-link,
    :host-context([theme="dark"]) .upgrade-link,
    :host([theme="dark"]) .upgrade-link {
      color: var(--p-primary-color, var(--p-emerald-400, #34d399));
    }
  </style>

  <div class="info-card" id="card" data-route="/billing">
    <div class="card-top">
      <div class="icon-container">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7z"/>
          <path d="M5 16h14v2H5z"/>
        </svg>
      </div>
      <div class="card-body">
        <h3 class="card-title" id="title">תקופת ניסיון</h3>
        <div class="card-value" id="value">0</div>
        <p class="card-subtitle" id="subtitle">ימים נותרו לניסיון</p>
      </div>
    </div>
    <div class="card-divider"></div>
    <div class="card-bottom">
      <span class="upgrade-link" id="upgradeLink">שדרוג מנוי</span>
    </div>
  </div>
`;

class TrialCard extends BaseInfoCard {
  constructor() {
    super(template);
  }

  static get observedAttributes() {
    return ["theme", "lang", "days-left"];
  }

  get defaultRoute() {
    return "/billing";
  }

  render() {
    const titleEl = this.shadowRoot.getElementById("title");
    const valueEl = this.shadowRoot.getElementById("value");
    const subtitleEl = this.shadowRoot.getElementById("subtitle");
    const upgradeLinkEl = this.shadowRoot.getElementById("upgradeLink");

    if (!titleEl || !valueEl || !subtitleEl || !upgradeLinkEl) return;

    const isHebrew = this.isHebrew;
    const daysLeft = this.getAttribute("days-left") || "0";

    titleEl.textContent = isHebrew ? "תקופת ניסיון" : "Trial";
    valueEl.textContent = `${daysLeft}`;
    subtitleEl.textContent = isHebrew ? "ימים נותרו לניסיון" : "Days left in trial";
    upgradeLinkEl.textContent = isHebrew ? "שדרוג מנוי" : "Upgrade plan";
  }
}

if (!customElements.get("trial-card")) {
  customElements.define("trial-card", TrialCard);
}

export { TrialCard };
